// Access model contents via React Hook
// Create a model listener which sets the state
import {useContext, useEffect, useState} from "react";
import {ClientBridge} from "../index";

export function useModel(model, itemType, setName, options) {

    options = options || {};
    const get = options.one ? 'getOne' : 'getSet';

    const myModel = model[itemType];
    const [data, setData] = useState(myModel[get](setName));

    useEffect(() => {

        const listenerId = myModel.addListener(
            setName,
            () => {
                //console.log('useModel dispatch: '+ itemType+ ' '+ setName);
                // todo may need to clone to force data change
                //  i.e. ,model could return SAME object that it knows (from the record version) is modified
                setData(data=>{
                    const newData = myModel[get](setName);
                    if (data===newData) {
                        console.log("WARNING: model event won't trigger hook: " + setName);
                    }
                    return newData;
                })
            }
        );

        return () => {
            //console.log('useModel unmount: ' + setName);
            myModel.removeListener(setName, listenerId);
        }

    }, [model, itemType, setName]);

    return data;
}

/*
Replacement for useModel that can be used like useState

const loginPerson = useModel(props.model, 'person', 'selected_login', {one:true});
==
const [loginPerson, setLoginPerson] = useModelSet('person', 'selected_login', {single:true});
OR
const [loginPerson, loginPersonSet] = useModelItem('person', 'selected_login');

 */

//Note: use of new setName *should* work
export function useModelSet(itemType, setName, options = {}) {

    const {model} = useContext(ClientBridge);
    const {single=false} = options;

    const [data, setData] = useState(single?undefined:[]);
    const [handler, setHandler] = useState({});
    // Note return Fn from function else used as lay init
    const [replaceFn, setReplaceFn] = useState(()=>()=>{});
    const [diff, setDiff] = useState();

    useEffect(() => {

        console.log('useModelSet uesEffect: '+ itemType+ ' '+ setName);
        const myModel = model[itemType];

        const newHandler = single
            ? myModel.getItemObject(setName)
            : myModel.getSetObject(setName);

        setHandler(newHandler);
        // Note return Fn from function else used as functional update
        setReplaceFn( ()=>value => newHandler.replace(value));
        setData(newHandler.get());

        const listenerId = myModel.addListener(
            setName,
            (newDiff) => {
                //console.log('useModelSet dispatch: '+ itemType+ ' '+ setName);
                //setData(newHandler.get())

                // todo may need to clone to force data change of single items
                //  i.e. ,model could return SAME object that it knows (from the record version) is modified
                setData(data=>{
                    const newData = newHandler.get();
                    if (data===newData) {
                        console.log("WARNING: model event won't trigger hook: " + setName);
                    }
                    return newData;
                });
                setDiff(newDiff);
            }
        );

        return () => {
            //console.log('useModelSet Removing listener: '+listenerId);
            myModel.removeListener(setName, listenerId);
        }

    }, [model, itemType, setName, single]);


    return [data, replaceFn, handler, diff];
}

export function useModelItem(itemType, setName) {
    return useModelSet(itemType,setName, {single:true})
}
